import { render, staticRenderFns } from "./pushlogisticstatus.vue?vue&type=template&id=ee38eed2&"
import script from "./pushlogisticstatus.vue?vue&type=script&lang=js&"
export * from "./pushlogisticstatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports